import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconRotate90Left12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconRotate90Left12"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#Rotate90Left12)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M2.5 1H4V0H2.5A2.5 2.5 0 0 0 0 2.5V4h1V2.5A1.5 1.5 0 0 1 2.5 1M7 2.5v-.024 2.042zM2.48 7h2.04zM10 10h.5A1.5 1.5 0 0 0 12 8.5v-7A1.5 1.5 0 0 0 10.5 0h-4A1.5 1.5 0 0 0 5 1.5V5H1.5A1.5 1.5 0 0 0 0 6.5v4A1.5 1.5 0 0 0 1.5 12h7a1.5 1.5 0 0 0 1.5-1.5zM6 1.5V5h2.5A1.5 1.5 0 0 1 10 6.5V9h.5a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0-.5.5M8.5 6h-7a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="Rotate90Left12">
                        <path fill="#fff" d="M12 0H0v12h12z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconRotate90Left12);
